import React from "react";

import PageMetaData from "../../components/PageMetaData/PageMetaData.js";
import TitleMain from "../../components/TitleMain/TitleMain.js";

const Calendar = () => {
  return (
    <>
      <PageMetaData title={"Calendar | jBot"} />
      <TitleMain>Calendar</TitleMain>
    </>
  );
};

export default Calendar;
